import { t } from '../i18n'

export const PRICE_TYPE = {
  ANN: t('constants.priceType.ANN'),
  BNN: t('constants.priceType.BNN'),
  QTL: t('constants.priceType.QTL'),
  MTL: t('constants.priceType.MTL'),
} as const
